import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Confirm from "../../assets/svg/Tick.gif";
import Lottie from "lottie-react";
import ConfirmTick from "../../assets/lottie/Tick.gif.json";
import CommonModal from "./CommonModal";
import "./Modal.css";
import { servicePost } from "../../helper/api";
const ConfirmationModal = (props) => {
  const [modalShow, setModalShow] = useState(false);

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const StatusChanged = async () => {
    const disbale = await servicePost(
      "api/v1/admin/kycReset",
      {
        user: props?.accountId,
      },
      notification,
      authToken
    );

    console.log("props=", props);
    setModalShow(true);
    props.onHide();
    window.location.reload();
  };

  useEffect(() => {
    setTimeout(() => {
      setModalShow(false);
    }, 2000);
  }, [modalShow]);

  return (
    <>
      <CommonModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        type="Your KYC status has been changed successfully."
      />
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="modal-main-wrapper">
            <div className="confirmation-modal-wrap">
              <h3>{props.type}</h3>
              <div className="modal-confirmation-button">
                <button className="confirm-btn" onClick={StatusChanged}>
                  Confirm
                </button>
                <button className="cancel-btn" onClick={() => props.onHide()}>
                  Cancel
                </button>
              </div>
            </div>

            <div className="modal-side-image-wrap">
              <img src="./images/modal-side-img.png" alt="img" />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfirmationModal;
